(function (angular) {
    'use strict';
    angular
        .module('app')
        .filter('trustAsHtmlFilter', function ($sce) {
            return function (html) {
                return $sce.trustAsHtml(html);
            };
        });
})(angular);